import { Location } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { AddTaskFormComponent } from '@shared/components';
import { ChecklistComponent } from '@app/modules/purchase-order/components/checklist/checklist.component';
import { Checklist } from '@models/checklist.model';
import { PurchaseOrderDto } from '@app/models/purchase-order.model.dto';

@Component({
  selector: 'ngx-checklist-step',
  templateUrl: './checklist-step.component.html',
  styleUrls: ['./checklist-step.component.scss'],
})
export class ChecklistStepComponent implements OnInit, AfterViewInit {
  @Input() purchaseOrder: PurchaseOrderDto;
  @Input() myStepper: MatStepper;
  @Input() companyType: string;
  @Input() checklist: Checklist = new Checklist();
  @Output() checklistChange: EventEmitter<Checklist> = new EventEmitter<Checklist>();
  @Output() saveDraft: EventEmitter<void> = new EventEmitter<void>();
  @Output() discard: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(ChecklistComponent, { static: true }) checklistComponentRef: ChecklistComponent;
  addTaskFormComponentRef: AddTaskFormComponent;

  isFormDirty;

  constructor(private location: Location) {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.addTaskFormComponentRef = this.checklistComponentRef.addTaskFormComponentRef;
    this.addTaskFormComponentRef.taskForm.valueChanges.subscribe(() => {
      this.isFormDirty = this.addTaskFormComponentRef.taskForm.dirty;
    });
  }

  checklistChanged(checklist) {
    this.checklist = checklist;
    this.checklistChange.emit(this.checklist);
  }

  goBack() {
    this.location.back();
  }
}
